var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
import { TextInfo } from './modules/TextInfo';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { strip } from '../../../utils/serializr/schema/inner/strip';
import { runtime } from '../../runtime/Runtime';
import { TextTags } from './modules/TextTags';
export class AttachedText extends AttachedContent {
    type = 'text';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get textBasis() {
        return this.valueOf.textBasis;
    }
    set textBasis(text) {
        this.local.valueOf.textBasis = text;
    }
    get textEdit() {
        return new runtime.solidPackages.Edit.classes.TextEdit(this);
    }
    get textInfo() {
        return new TextInfo(this);
    }
    get textOutputString() {
        return this.core.aspectTextTransform.transformedText;
    }
    get textTags() {
        return new TextTags(this);
    }
    get isEmpty() {
        return !this.textOutputString || this.textOutputString.length === 0;
    }
    get autoTags() {
        return [...this.textTags.autoTags, ...super.autoTags];
    }
    static get stripInfo() {
        return {
            extends: AttachedContent.stripInfo,
            props: {
                text: strip((at) => at.textBasis),
            },
        };
    }
}
__decorate([
    computed
], AttachedText.prototype, "textBasis", null);
__decorate([
    memoize
], AttachedText.prototype, "textEdit", null);
__decorate([
    memoize
], AttachedText.prototype, "textInfo", null);
__decorate([
    computed
], AttachedText.prototype, "textOutputString", null);
__decorate([
    memoize
], AttachedText.prototype, "textTags", null);
__decorate([
    computed
], AttachedText.prototype, "isEmpty", null);
__decorate([
    memoize
], AttachedText, "stripInfo", null);
